import Type from "@/model/types/Type";

const type = {
    LEFT: "L",
    CENTER: "C",
    RIGHT: "R",
}

const list = [
    {
        value: type.LEFT,
        text: "Esquerda",
    },
    {
        value: type.CENTER,
        text: "Centro",
    },
    {
        value: type.RIGHT,
        text: "Direita",
    },

]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}